// extracted by mini-css-extract-plugin
export default {"table_container":"table_table_container__u9M6t","search":"table_search__mpPBS","table":"table_table__GDmBv","arrow":"table_arrow__BfC3h","hidden":"table_hidden__40u0K"};